module.exports = {"TXTWCL_RatingX_N0_out_of_N1_stars":{"id":"TXTWCL_RatingX_N0_out_of_N1_stars","defaultMessage":"Bedømmelse: {0} ud af {1} stjerner"}}